(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tab-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length === 0 || tabContents.length === 0) return;

    tabContents[0].classList.add('is-active');

    tabTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        e.preventDefault();
        tabContents.forEach(content => {
          content.classList.remove('is-active');
        });
        const tabContent = this.nextElementSibling;
        if (tabContent) {
          tabContent.classList.add('is-active');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelectorAll('.tab-title-text');
        if (tabTitleText.length > 0) {
          tabTitleText.forEach(text => {
            text.textContent = toggleLink.textContent;
          });
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["subtotal"] && !Shopify.designMode) return;
  try {
    (() => {
    const initSubtotal = (subtotalNode) => {
      if (!subtotalNode || subtotalNode.dataset.subtotalReady === 'true') return;
      subtotalNode.dataset.subtotalReady = 'true';

      const sectionId = subtotalNode.dataset.sectionId;
      const productForm = subtotalNode.closest('product-form-component');
      if (!productForm) return;

      const subtotalPriceEl = subtotalNode.querySelector('[data-subtotal-price]');
      const variantsDataNode = subtotalNode.querySelector('[data-subtotal-variants]');
      if (!subtotalPriceEl || !variantsDataNode) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsDataNode.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const quantityInput = productForm.querySelector(`#Quantity-${sectionId}`) || productForm.querySelector('.quantity__input');
      const variantInput = productForm.querySelector('input[name="id"]');
      if (!quantityInput || !variantInput) return;

      const formatMoney = (cents) => {
        if (Shopify && typeof Shopify.formatMoney === 'function') {
          const formatted = Shopify.formatMoney(cents, window.money_format || subtotalNode.dataset.moneyFormat);
          const textOnly = String(formatted).replace(/<[^>]*>/g, '');
          return textOnly;
        }
        return null;
      };

      const updateSubtotal = () => {
        const quantity = Math.max(1, Number(quantityInput.value) || 1);
        const selectedVariantId = String(variantInput.value || '');
        const selectedVariant = variants.find((variant) => String(variant.id) === selectedVariantId);
        if (!selectedVariant) return;

        const formattedSubtotal = formatMoney(selectedVariant.price * quantity);
        if (!formattedSubtotal) return;
        subtotalPriceEl.textContent = formattedSubtotal;
      };

      updateSubtotal();
      quantityInput.addEventListener('input', updateSubtotal);
      quantityInput.addEventListener('change', updateSubtotal);
      variantInput.addEventListener('change', updateSubtotal);

      const variantObserver = new MutationObserver(updateSubtotal);
      variantObserver.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    };

    const initAllSubtotals = () => {
      document.querySelectorAll('[data-product-subtotal]').forEach(initSubtotal);
    };

    initAllSubtotals();
    document.addEventListener('DOMContentLoaded', initAllSubtotals);
    document.addEventListener('shopify:section:load', initAllSubtotals);
    document.addEventListener('product-info:loaded', initAllSubtotals);
  })();
  } catch(e) { console.error(e); }
})();

})();
